import { gql } from "@apollo/client";

export const END_SESSION = gql`
  mutation endSession($sessionID: Int!) {
    endSession(sessionID: $sessionID) {
      durationInMinutes
      totalPrice
      # Недозвон: status приходит failed, если по сессии не создан billing_event.
      # Заполняется только в ответе endSession (в Session.statistics пусто — там есть Session.status).
      status
    }
  }
`;
